export default __webpack_public_path__ + "static/media/icon-bug.bea752d7.svg";